module.exports = __webpack_public_path__ + "static/media/btn_colaps.a06002ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/btn_colaps.svg
// module id = 612
// module chunks = 0